/**
 * Local Unleash SDK bootstrap (mirrors @pw-tech/unleash UnleashSDK).
 * We cannot import from `@pw-tech/unleash/react` in CRA — that package is ESM
 * with extensionless imports and fails webpack fullySpecified resolution.
 */

export type UnleashEnv =
  | 'production'
  | 'pre-production'
  | 'staging'
  | 'development'

export const mapAppEnvToUnleashEnv = {
  local: 'staging',
  dev: 'development',
  development: 'development',
  stage: 'staging',
  staging: 'staging',
  'pre-prod': 'pre-production',
  'pre-production': 'pre-production',
  preproduction: 'pre-production',
  demo: 'pre-production',
  prod: 'production',
  production: 'production',
  main: 'production',
} as const

export type AppEnv = keyof typeof mapAppEnvToUnleashEnv

export type UnleashSDKConfig = {
  env: UnleashEnv
  appVersion: string
  enableLogs?: boolean
  api: {
    headers: Record<string, string>
    enableAnalytics?: boolean
  }
}

let sdkConfig: UnleashSDKConfig | null = null

export const UnleashSDK = {
  initialise(config: UnleashSDKConfig) {
    if (typeof window === 'undefined') return
    sdkConfig = config
    if (config.enableLogs) {
      console.log('[UnleashSDK] initialized', { env: config.env })
    }
  },
  isInitialised() {
    return !!sdkConfig
  },
  getConfig() {
    return sdkConfig
  },
}

export const getUnleashEnv = (): UnleashEnv =>
  mapAppEnvToUnleashEnv[process.env.REACT_APP_ENV as AppEnv] || 'production'

export const initializeUnleashSDK = () => {
  if (typeof window === 'undefined') return
  if (UnleashSDK.isInitialised()) return

  UnleashSDK.initialise({
    env: getUnleashEnv(),
    appVersion: process.env.REACT_APP_PP_CLIENT_VERSION || '0.1.0',
    enableLogs: process.env.REACT_APP_ENV !== 'production',
    api: {
      headers: {},
      enableAnalytics: !window.location.href.includes('localhost'),
    },
  })
}
